module.exports = __webpack_public_path__ + "img/checkerboard.c8b4c552.png";